import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import { DB_CONFIG } from './config/config'

//Components
import LoginForm from './components/login-form';
import SideMenu from './components/side-menu';

import './statics/css/app.css';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  withRouter,
  Redirect
} from 'react-router-dom'


import Logo from './statics/images/logo_default_white.png'
import iconTreino from './statics/images/dumbell.svg'
import { Image } from 'react-bootstrap';
import { Glyphicon } from 'react-bootstrap';
import ListAlunos from './components/alunos/users-list';
import Calendary from './components/agenda/calendar';
//import TimeSchedule from './components/agenda/time-schedule';
import AlunoDetail from './components/alunos/user-detail';
import MountTraining from './components/treinos/mount-training';

import { singOut } from './dao-firebase/user-firebase';
import TableTrainings from './components/treinos/table-trainings';
import ExercisesList from './components/treinos/exercises-list';
import TrainingsList from './components/treinos/trainings-list';
import PublicationsList from './components/feed/publications-list'
import ConsultContract from './components/contracts/consult-contract';
import PersonalContract from './components/contracts/personal-contract';
import Anamnese from './components/alunos/user-anamnese';
import BottomMenu from './components/bottom-menu';
// import PagSeguro from './components/payment/pagseguro';
//import HoursConfiguration from './components/agenda/hours-configuration'



class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
    };

  }

  componentWillMount() {
    //this.props.history.push('/login');

    //Para erros no localStorage
    // localStorage.clear();
    // singOut();
  }

  handleMenu(menu) {

    if (menu == 'logout') {
      localStorage.clear();
      singOut();
      this.props.history.push('/login');
    } else {
      this.props.history.push('/' + menu);
    }

  }

  verifyUser() {
    if (JSON.parse(localStorage.getItem("USER")) == undefined || JSON.parse(localStorage.getItem("USER")) == null) {

      this.props.history.push('/login')

    } else {

      //Verificando se é professor
      console.log(localStorage.getItem("USER"));
      if (JSON.parse(localStorage.getItem("USER")).role == 'professor') {

        this.setState({
          user_role: 'professor',
        })

        this.props.history.push('/alunos')

      } else {

        //Quando é aluno

        this.setState({
          user_role: 'student',
        })

        this.props.history.push({
          pathname: '/aluno/anamnese',
          state: {
            user: JSON.parse(localStorage.getItem("USER"))
          },
        })

      }

      // switch (JSON.parse(localStorage.getItem("USER")).role) {

      //   case 'student':

      //     this.setState({
      //       user_role: 'student',
      //     })

      //     this.props.history.push({
      //       pathname: '/aluno/anamnese',
      //       state: {
      //         user: JSON.parse(localStorage.getItem("USER"))
      //       },
      //     })

      //     break;


      //   case 'professor':
      //     this.setState({
      //       user_role: 'professor',
      //     })

      //     this.props.history.push('/alunos')

      //     break;
      // }

      console.log("USER LOGADO: " + localStorage.getItem("USER"));
    }

    this.setState({
      loaded: false,
    })
  }

  componentDidMount() {

    this.verifyUser();

  }

  render() {

    return (
      <div className="App">
        <div className="wrapper">

          {/* {
            JSON.parse(localStorage.getItem("USER")) != undefined && JSON.parse(localStorage.getItem("USER")).role == "professor" ?
              <SideMenu onHandleMenu={(menu) => this.handleMenu(menu)} />
              :
              null
          } */}

          <SideMenu onHandleMenu={(menu) => this.handleMenu(menu)} />

          <BottomMenu onHandleMenu={(menu) => this.handleMenu(menu)} />

          <div id="content">
            <Switch>
              <Route exact path="/alunos" component={ListAlunos} />
              {/* <Route exact path="/agenda/calendar" component={TimeSchedule} /> */}
              {/* <Route exact path="/agenda/configuration" component={HoursConfiguration} /> */}
              <Route exact path="/agenda/configuration" component={Calendary} />
              <Route exact path="/aluno_detail" component={AlunoDetail} />
              <Route exact path="/treino/exercisesList" component={ExercisesList} />
              <Route exact path="/treino/trainingsList" component={TrainingsList} />
              <Route exact path="/feed/publications" component={PublicationsList} />
              <Route exact path="/treino/montar" component={MountTraining} />
              <Route exact path="/contratos/consult" component={ConsultContract} />
              <Route exact path="/contratos/personal" component={PersonalContract} />
              <Route exact path="/aluno/anamnese" component={Anamnese} />
              {/* <Route exact path="/payment" component={PagSeguro} /> */}
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// src/App.js